import {Accordion, AccordionDetails, AccordionSummary, Grid, Typography, useTheme, Box} from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMore";
import {useTranslation} from "react-i18next";
import {PieChart, Pie, Cell, ResponsiveContainer, Text} from "recharts";
import {useState, useCallback, useMemo} from "react";

interface DaysAccordionProps {
    used?: number;
    booked?: number;
    total?: number;
}

const DaysAccordion = ({used = 0, booked = 0, total = 240}: DaysAccordionProps) => {
    
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'daysAccordion'});
    const [activeIndex, setActiveIndex] = useState(0);
    const theme = useTheme();

    const data = [
        {name: "availableDays", value: total - (booked + used), color: theme.palette.primary.main},
        {name: "bookedDays", value: booked, color: theme.palette.secondary.main},
        {name: "usedDays", value: used, color: theme.palette.accent.main},
    ]

   
    function DaysCounterPieChartLegend({dataToRender}:{dataToRender:typeof data}){
        return (
            <Box marginTop={'90px'} display={'flex'} flexDirection={'column'} gap={'12px'}>
                {dataToRender.map((label) => (
                    <Box style={{
                        display: "flex",
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <Box display={'flex'} gap={'10px'} alignItems={'center'}>
                            <span style={{
                                border: "1px solid " + label.color,
                                backgroundColor: label.color,
                                borderRadius: "50%",
                                display: "inline-block",
                                height: "14px",
                                width: "14px",
                            }}/>
                            <Typography sx={{display: 'inline'}}
                                        variant={'h6'}>{t(`${label.name}`)}</Typography>
                        </Box>
                        <Typography variant={'h6'}
                                    color={label.color}>
                                        {label.name === 'availableDays' ? total - (booked + used)+'/'+ total :
                                         label.name === 'bookedDays' ? booked :
                                          used 
                                        }  {t('days')}
                        </Typography>
                    </Box>
                ))}
        </Box>
        )
    }

    const renderLabels = useMemo(() => {
        return (
            <>
                <text
                    /*  scaleToFit={true}*/
                    x={145}
                    y={135}
                    textAnchor={'middle'}
                    style={{
                        fontSize: '2rem',
                        fontWeight: 'bold',
                        color: theme.palette.primary.main
                    }}
                >{total - (booked + used)}
                </text>
                <text
                    /*  scaleToFit={true}*/
                    x={145}
                    y={165}
                    textAnchor={'middle'}
                    style={{fontWeight: '250', fontSize: '1.25rem'}}
                > {t('of')} {total}
                </text>
            </>
        )
    }, [data]);

    /*   const onPieEnter = useCallback(
           (_: any, index: any) => {
               setActiveIndex(index);
               console.log('PieEnter')
           },
           [setActiveIndex]
       );
   */
    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreRoundedIcon/>}>
                <Typography>{t('title')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={2} sx={{maxHeight: '300px'}}>
                    <Grid item xs={4}>
                        <Box sx={{width: '100%', height: '100%'}}>
                            <ResponsiveContainer width={'100%'} aspect={1}>
                                <PieChart>
                                    <Pie
                                        activeIndex={activeIndex}
                                        //activeShape={renderActiveShape}
                                        data={data}
                                        cx={140}
                                        cy={130}
                                        innerRadius={75}
                                        outerRadius={95}
                                        fill="#8884d8"
                                        dataKey="value"
                                        //onMouseEnter={onPieEnter}
                                        legendType={"line"}
                                        blendStroke={true}
                                        label={renderLabels}
                                        labelLine={false}
                                    >
                                        {data.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={entry.color}/>
                                        ))}
                                    </Pie>
                                </PieChart>
                            </ResponsiveContainer>
                        </Box>
                    </Grid>
                    <Grid item xs={5}>
                        <DaysCounterPieChartLegend dataToRender={data} />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}



export default DaysAccordion;